import { useCallback } from 'react';
import { KeySequence } from 'app/lib/constants';
import { useDispatch, useMousetrap, useSelector } from 'app/lib/hooks';
import { selectIsJobManagementEnabled } from 'app/store/applicationConfig';
import { doToggleCreateProjectDialog, selectIsCreateProjectDialogOpen } from 'app/store/projects';
import { CreateProjectWithModelDialog } from './CreateProjectWithModelDialog.jsx';
import { LegacyCreateProjectDialog } from './LegacyCreateProjectDialog.jsx';

export function CreateNewProjectDialogLauncher() {
    const dispatch = useDispatch();
    const canManageProjectModels = useSelector(selectIsJobManagementEnabled);
    const isOpen = useSelector(selectIsCreateProjectDialogOpen);

    const toggleDialog = useCallback(() => {
        dispatch(doToggleCreateProjectDialog());
    }, [dispatch]);

    useMousetrap(KeySequence.CREATE_PROJECT_DIALOG, toggleDialog);

    if (!isOpen) {
        return null;
    }

    return canManageProjectModels ? (
        <CreateProjectWithModelDialog onClose={toggleDialog} />
    ) : (
        <LegacyCreateProjectDialog onClose={toggleDialog} />
    );
}
